import apiClient from '../../../../api/apiConfig';
import { WorkflowServerExpect } from '../../ServerWorkflowType';

const BASE_URL = '/csb/workflows';

export const fetchWorkflowById = async (
  name?: string | null
): Promise<WorkflowServerExpect> => {
  if (!name) {
    throw new Error('Workflow name is required');
  }
  const response = await apiClient.get<WorkflowServerExpect>(
    `${BASE_URL}/${name}`
  );
  return response.data;
};
